// https://github.com/dperish/prettyFloat.js
export function prettyFloat(value, precision = 6) {
    if (value == null) {
        return '';
    }
    const str = precision != null ? value.toFixed(precision) : value.toString();
    return str.replace(/([,.]\d*?)0+$/, '$1').replace(/\.$/, '');
}
export function pad0(str, width) {
    str = str.toString();
    while (str.length < width)
        str = '0' + str;
    return str;
}
export function isFloat(str) {
    // http://stackoverflow.com/questions/18082/validate-numbers-in-javascript-isnumeric
    str = str.trim().replace(',', '.');
    const float = parseFloat(str);
    return !isNaN(float) && isFinite(float);
}
export function parseFloatWithComma(str) {
    if (str == null)
        return null;
    if (typeof str == 'string' && str.trim() == '')
        return null;
    if (typeof str == 'number')
        return str;
    if (!isFloat(str))
        return NaN;
    return parseFloat(str.replace(',', '.'));
}
export function isInteger(str) {
    return !isNaN(parseInt(str)) && parseFloat(str) == parseInt(str);
}
export const hasBit = (value, bit) => (value & (1 << bit)) != 0;
export const hasBitVal = (value, bitVal) => (value & bitVal) != 0;
